import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { startAuthTimer, clearAuthTimer } from '../utils/authTimer';
import { getTimeoutForUser } from '../utils/sessionConfig';
import { useRecordLogoutMutation } from '../slices/userLoginAuditApiSlice';

const AuthMonitor = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [recordLogout] = useRecordLogoutMutation();

  useEffect(() => {
    if (!userInfo) return;

    const resetTimer = () => {
      const timeout        = getTimeoutForUser(userInfo);
      const expirationTime = new Date().getTime() + timeout;
      localStorage.setItem('expirationTime', expirationTime);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress',  resetTimer);
    window.addEventListener('click',     resetTimer);

    // Pass the audit call as a callback — runs inside an async context
    startAuthTimer(dispatch, navigate, () =>
      recordLogout({
        eventType: 'logout_auto',
        note: 'Session timed out due to inactivity',
      }).unwrap()
    );

    return () => {
      clearAuthTimer();
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress',  resetTimer);
      window.removeEventListener('click',     resetTimer);
    };
  }, [dispatch, navigate, userInfo, recordLogout]);

  return null;
};

export default AuthMonitor;